import Button from '@/common/components/base/button/Button';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import { useState } from 'react';
import { Box } from 'styled-system/jsx';
import AddSvg from '@/common/assets/icons/add.svg?react';
import { token } from 'styled-system/tokens';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getBodyWagesListQueryOption } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyWagesList/getBodyWagesListQueryOption';
import BodyWagesModal from '@/modules/adjusterReportModules/Insurer-information/components/expert/modals/BodyWagesModal';
import BodyWagesList from '@/modules/adjusterReportModules/Insurer-information/components/expert/BodyWagesList';

export default ({ isEditable = true }: { isEditable?: boolean }) => {
  return (
    <MainLayout title="بیمه گذار / کارشناسی" header="titleHeader">
      <BodyWagesPage isEditable={isEditable} />
    </MainLayout>
  );
};

const BodyWagesPage = ({ isEditable = true }: { isEditable?: boolean }) => {
  const { id } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const { refetch: refetchWagesList } = useQuery(
    getBodyWagesListQueryOption({ id: +id! }),
  );
  return (
    <Box pt={24}>
      <BodyWagesModal
        open={openModal}
        setOpenModal={() => {
          refetchWagesList();
          setOpenModal(false);
        }}
      />
      <TitleDescription>اجرت تعمیرات</TitleDescription>
      {isEditable && (
        <Button
          fullWidth
          mt={24}
          variant="outlined"
          color="success"
          onClick={() => setOpenModal(true)}
        >
          <Box mx={12}>
            <AddSvg stroke={token('colors.green-2')} width={20} height={20} />
          </Box>
          افزودن نوع تعمیر
        </Button>
      )}
      <BodyWagesList isEditable={isEditable} />
    </Box>
  );
};
